(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    let submitTimer;

    const scheduleSubmit = (form) => {
      clearTimeout(submitTimer);
      submitTimer = setTimeout(() => form.requestSubmit(), 500);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-adjust]');
      if (!button) return;

      const controls = button.closest('.cart-item__quantity-controls');
      const input = controls && controls.querySelector('[data-quantity-input]');
      if (!input) return;

      const step = Number(button.dataset.quantityAdjust);
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      if (next === Number(input.value)) return;

      input.value = next;
      scheduleSubmit(input.form);
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-quantity-input]');
      if (!input) return;

      if (input.value === '' || Number(input.value) < 0) input.value = 0;
      scheduleSubmit(input.form);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-product"]) return;
  try {
    
  if (!customElements.get('ks-gallery')) {
    class KsGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || this.dots.length < 2) return;

        this.prev.addEventListener('click', () => this.go(this.index - 1));
        this.next.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(this.index - 1);
          if (event.key === 'ArrowRight') this.go(this.index + 1);
        });
        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(() => this.sync());
        });
        this.sync();
      }

      get index() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      go(index) {
        const target = Math.max(0, Math.min(index, this.dots.length - 1));
        this.track.scrollTo({ left: target * this.track.clientWidth });
      }

      sync() {
        const current = this.index;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
        this.prev.disabled = current === 0;
        this.next.disabled = current === this.dots.length - 1;
      }
    }

    customElements.define('ks-gallery', KsGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.launch-header__panel a');
    if (link) link.closest('details')?.removeAttribute('open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.launch-header__burger[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-variant-radio]');
    if (!input) return;

    const container = input.closest('[data-product]');
    if (!container) return;

    const priceDisplay = container.querySelector('[data-price-display]');
    const compareDisplay = container.querySelector('[data-compare-display]');
    const submit = container.querySelector('[data-submit]');
    const mediaItems = container.querySelectorAll('[data-media-item]');

    if (priceDisplay) priceDisplay.textContent = input.dataset.price;

    if (compareDisplay) {
      if (input.dataset.comparePrice) {
        compareDisplay.textContent = input.dataset.comparePrice;
        compareDisplay.hidden = false;
      } else {
        compareDisplay.hidden = true;
      }
    }

    if (submit) {
      const soldOut = input.hasAttribute('data-unavailable');
      submit.disabled = soldOut;
      submit.textContent = soldOut ? submit.dataset.labelSoldOut : submit.dataset.labelAdd;
    }

    if (mediaItems.length > 0) {
      const mediaId = input.dataset.mediaId;
      mediaItems.forEach((item, index) => {
        if (mediaId) {
          item.hidden = item.dataset.mediaId !== mediaId;
        } else {
          item.hidden = index > 0;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
